import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = void;
type Response = { success: boolean };

export const useDeleteBankAccount = createMutation<
  Response,
  Variables,
  AxiosError
>({
  mutationFn: async () =>
    client({
      url: 'v2/internal/partners/bank_accounts',
      method: 'DELETE',
    })
      .then((response) => response.data)
      .catch((err: any) => {
        const errors = err.response?.data?.errors;
        throw new Error(
          Array.isArray(errors)
            ? errors.join(', ')
            : 'Failed to remove bank account'
        );
      }),
});
